import { z } from "zod";

export const referralSchema = z.object({
  reason: z.string().nonempty("Required"),
  provider: z.string().nonempty("Required"),
  urgency: z.string().nonempty("Required"),
  direction: z.string().optional(),
});
